<div class="number">
  {{ value() }}
  @if (!hidePercent()) {
    <div
      class="percent">
      ({{ percent() | number:'1.0-0':'sv' }} %)
    </div>
  }
</div>